import Box from "./Box";
import React from "react";

function TakebackFormCell({ children }) {
  return (
    <Box display="flex" px={["12px", 40, null, null]} alignItems="center">
      {children}
    </Box>
  );
}

export default TakebackFormCell;
